import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import React, { useMemo } from 'react';
import { citiesStore } from '../store';
import ItemComponent from './ItemComponent';
import { Card } from '@totalsoft/rocket-ui';
import ListAlt from '@mui/icons-material/ListAlt';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import { CITIES } from 'features/city/queries';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import CityBrowserFilters from './CityBrowserFilters';

const BrowserComponent = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: CITIES,
        name: 'pagedCities'
      }
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'type', caption: 'City.Type', width: '75px' },
      { name: 'code', caption: 'City.Code' },
      { name: 'name', caption: 'City.Name' },
      { name: 'inactive', caption: 'City.Inactive', align: 'center', width: '15%' },
      { name: 'actions', caption: 'Actions', width: '175px' }
    ],
    []
  );

  return (
    <Card icon={ListAlt}>
      <TableListBrowser store={citiesStore} ItemComponent={ItemComponent} columns={columns} />
      <ExportModalComponent store={citiesStore} options={fetchingOptions} />
      <CityBrowserFilters />
      <ApolloFetchingComponent store={citiesStore} options={fetchingOptions} />
    </Card>
  );
};

export default BrowserComponent;
